import axios from 'axios'
import cookies from '../utils/cookies'

const baseURL = process?.env?.REACT_APP_API_URL || 'http://localhost:8000'
const remove = async (url, options = { includeToken: true }) => {
  const headers = {}
  if (options.includeToken) {
    headers['Authorization'] = 'Bearer ' + cookies.get('accesToken')
  }
  const instance = axios.create({
    baseURL,
    timeout: 40000,
    headers,
  })
  return await instance.delete(url, options)
}

const put = async (url, body, options = { includeToken: true }) => {
  const headers = {}
  if (options.includeToken) {
    headers['Authorization'] = 'Bearer ' + cookies.get('accesToken')
  }
  const instance = axios.create({
    baseURL,
    timeout: 40000,
    headers,
  })
  return await instance.put(url, body, options)
}

const post = async (url, body, options = { includeToken: true }) => {
  const headers = {}
  if (options.includeToken) {
    headers['Authorization'] = 'Bearer ' + cookies.get('accesToken')
  }
  const instance = axios.create({
    baseURL,
    timeout: 40000,
    headers,
  })
  return await instance.post(url, body, options)
}

const get = async (url, options = { includeToken: true }) => {
  const headers = {}
  if (options.includeToken) {
    headers['Authorization'] = 'Bearer ' + cookies.get('accesToken')
  }
  const instance = axios.create({
    baseURL,
    timeout: 40000,
    headers,
  })
  return await instance.get(url, options)
}

export default { remove, put, post, get }
